import reportTableStyles from "../ReportTable/ReportTable.module.css";
import styles from "./HrCompletionComment.module.css";

type HrCommentDisplayProps = {
  comment: string;
};

export default function HrCommentDisplay({ comment }: HrCommentDisplayProps) {
  return (
    <div
      className={reportTableStyles.categorySection}
      aria-label="Comentário dos Recursos Humanos"
    >
      <div
        className={`${reportTableStyles.mobileCategoryHeader} ${styles.mobileReportHeader}`}
      >
        Comentário dos Recursos Humanos
      </div>
      <div className={reportTableStyles.tableWrapper}>
        <table className={reportTableStyles.table}>
          <thead>
            <tr>
              <th className={reportTableStyles.categoryHeader} colSpan={1}>
                Comentário dos Recursos Humanos
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                className={`${reportTableStyles.tableContentCell} ${styles.displayContentCell}`}
              >
                <p className={styles.savedComment}>{comment}</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
